
import HelperEnv from './HelperEnv';
import HelperApis from '../helpers/HelperApis';
import HelperVehicle from './HelperVehicle';

class HelperWidget {

	static getInstanceWidgetReloadFunction(settings, reloadFunction) {
		const widgetSFS = document.getElementById('widget-sfs');
		const widgetSFSSide = document.getElementById('widget-sfs-side');
		const widgetSFSModal = document.getElementById('widget-sfs-modal');

		if (widgetSFS && settings.widgetType === 'WIDSFSPLAIN') {
			return () => {
				widgetSFS.reload();
				reloadFunction();
			};
		} else if (widgetSFSSide && settings.widgetType === 'WIDSFSSIDE') {
			return () => {
				widgetSFSSide.setAttribute('z-index',settings.zindex)
				widgetSFSSide.reload();
				reloadFunction();
			};
		} else if (widgetSFSModal && settings.widgetType === 'WIDSFSMODAL') {
			return () => {
				widgetSFSModal.setAttribute('z-index',settings.zindex)
				widgetSFSModal.reload();
				reloadFunction();
			};
		}
		return () => { };
	}

	static initWidget(functionnalPayload, settings, env, widgetState, onOpenWidget, checkOutputWidget) {
		const widgetSFS = document.getElementById('widget-sfs');
		const widgetSFSSide = document.getElementById('widget-sfs-side');
		const widgetSFSModal = document.getElementById('widget-sfs-modal');
		if (widgetSFS && !widgetSFS.getAttribute('eventInitialised')) {
			widgetSFS.addEventListener('onSubmit', (event) => HelperWidget.onSubmitWidget(null, event, checkOutputWidget));
			widgetSFS.setAttribute('eventInitialised', true);
		}
		if (widgetSFSSide && !widgetSFSSide.getAttribute('eventInitialised')) {
			widgetSFSSide.addEventListener('onSubmit', (event) => HelperWidget.onSubmitWidget(widgetSFSSide, event, checkOutputWidget));
			widgetSFSSide.setAttribute('eventInitialised', true);
		}
		if (widgetSFSModal && !widgetSFSModal.getAttribute('eventInitialised')) {
			widgetSFSModal.addEventListener('onSubmit', (event) => HelperWidget.onSubmitWidget(widgetSFSModal, event, checkOutputWidget));
			widgetSFSModal.setAttribute('eventInitialised', true);
		}
		let openWidget = (vehicle) => { };
		if (window.Psawidsimufin && settings.widgetType === 'WIDBPF') {
			const Psawidsimufin = window.Psawidsimufin;
			const instanceWidget = Psawidsimufin.new({ selector: '#wid00simulation' });
			openWidget = (vehicle) => {
				instanceWidget.render(HelperWidget.buildWidgetPayload(functionnalPayload, vehicle,
					env, settings, checkOutputWidget));
				onOpenWidget(true);
			}
		} else if (widgetSFS && settings.widgetType === 'WIDSFSPLAIN') {
			openWidget = HelperWidget.buildOpenWidgetFunction(widgetSFS, false, widgetState, functionnalPayload,
				{ env: env, settings: settings }, checkOutputWidget, onOpenWidget);
		} else if (widgetSFSSide && settings.widgetType === 'WIDSFSSIDE') {
			openWidget = HelperWidget.buildOpenWidgetFunction(widgetSFSSide, true, widgetState, functionnalPayload,
				{ env: env, settings: settings }, checkOutputWidget, onOpenWidget);
		} else if (widgetSFSModal && settings.widgetType === 'WIDSFSMODAL') {
			openWidget = HelperWidget.buildOpenWidgetFunction(widgetSFSModal, true, widgetState, functionnalPayload,
				{ env: env, settings: settings }, checkOutputWidget, onOpenWidget);
		}
		return openWidget;
	}

	static buildOpenWidgetFunction(widget, isWrapper, widgetState, functionnalPayload,
		envSettingsPayload, checkOutputWidget, onOpenWidget) {
		return (vehicle) => {
			if (widgetState.isPayloadToProvide || !isWrapper) {
				widget.setAttribute('payload', JSON.stringify(HelperWidget.buildWidgetPayload(functionnalPayload, vehicle,
					envSettingsPayload.env, envSettingsPayload.settings, checkOutputWidget)));
			}
			onOpenWidget(true);
			if (isWrapper) {
				widget.open();
			}
		};
	}

	static onSubmitWidget(widgetWrapper, event, checkOutputWidget) {
		if (event.detail) {
			checkOutputWidget(event.detail);
		}
	}

	static buildWidgetBPFInputs(contextWid, settings, vehicle, partExchange, parameters, widgetParameters) {
		const widgetInputs = { context: contextWid, vehicle: HelperVehicle.getVehicleWidget(vehicle, settings.vehDescType) };
		if (parameters != null && Object.values(parameters).length > 0) {
			widgetInputs.parameters = parameters;
		}
		if (partExchange != null && Object.values(partExchange).length > 0) {
			widgetInputs.partExchange = partExchange;
		}
		if(settings.zindex != null && settings.zindex.length > 0){
			widgetInputs.overrideStyle = {zIndex:settings.zindex};
		}
		return widgetInputs;
	}

	static buildWidgetPayload(functionnalPayload, vehicle, env, settings, checkOutputWidget) {

		const overrideComponentCode = functionnalPayload.context.overrideComponentCode ? functionnalPayload.context.overrideComponentCode : 'WIDCALCTEST';
		const context = {...functionnalPayload.context, overrideComponentCode:overrideComponentCode};
		const parameters = functionnalPayload.parameters;
		const parametersForFetch = functionnalPayload.parametersForFetch;
		const partExchange = functionnalPayload.partExchange;
		const widgetParameters = functionnalPayload.widgetParameters;
		const isDebugMode = functionnalPayload.isDebugMode;

		const widgetEnv = {
			WID_FINANCE_SIMU_BASE_URL: HelperEnv.getWidgetInputBaseUrl(settings),
			WID_FINANCE_SIMU_CLIENT_ID: HelperEnv.getSimuClientId(settings)
		}
		const isAuth = HelperEnv.isAuthSimulationPublic(env, settings);
		if (isAuth) {
			widgetEnv['Authorization'] = HelperApis.getBasicAuth(env);
		}
		if (settings.widgetType === 'WIDBPF') {
			return {
				context: HelperWidget.buildWidgetBPFInputs(context, settings, vehicle, partExchange, parameters, widgetParameters),
				environment: widgetEnv,
				isDebugMode: isDebugMode,
				outputFn: (output) => checkOutputWidget(output)
			}
		}
		widgetEnv['WID_FINANCE_SIMU_BASE_URL'] = `${widgetEnv['WID_FINANCE_SIMU_BASE_URL']}/onlinefinance-simulation-offer/v1`;
		if (isAuth) {
			widgetEnv['AUTHORIZATION'] = widgetEnv['Authorization'];
		}
		const payload = {
			context: context,
			vehicle: HelperVehicle.getVehicleWidget(vehicle, settings.vehDescType),
			environment: { ...widgetEnv },
			isDebugMode: isDebugMode,
		};
		if (parametersForFetch != null && Object.keys(parametersForFetch).length > 0) {
			payload['parameters'] = parametersForFetch;
		}
		if (partExchange != null && Object.keys(partExchange).length > 0) {
			payload['partExchange'] = partExchange;
		}
		return payload;
	}
}

export default HelperWidget
